<template>
  <v-menu offset-y left :close-on-content-click="false" v-model="isOpen">
    <template v-slot:activator="{ on }">
      <v-btn text color="primary" v-on="on" @click="isOpen = !isOpen">
        <v-icon small>mdi-tune</v-icon>
        <span class="ml-2">{{ $t("va.datatable.customize_columns") }}</span>
      </v-btn>
    </template>
    <div class="dynamic-columns-wrapper">
      <div class="dynamic-columns-title">
        <span>
          {{ $t("va.datatable.customize_columns") }}
        </span>
        <v-icon small @click="isOpen = false"> mdi-close </v-icon>
      </div>
      <v-list class="dynamic-columns-list">
        <v-list-item-group
          :value="selectedColumns"
          @change="updateSelectedColumns"
          multiple
        >
          <v-list-item
            v-for="(item, index) in columns"
            :key="index"
            :value="item.id"
            :disabled="item.required"
          >
            <template>
              <v-list-item-action>
                <v-checkbox
                  :disabled="item.required"
                  :input-value="item.active"
                  color="primary"
                  :label="item.label"
                ></v-checkbox>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
      columns: [],
      selectedColumns: [],
    };
  },
  mounted() {
    this.columns = this.value.map((val) => {
      if (val.required) {
        return { ...val, active: true };
      }
      return val;
    });
    this.selectedColumns = this.columns
      .filter((column) => column.active)
      .map((column) => column.id);
  },
  watch: {
    value: {
      handler: function (val) {
        this.selectedColumns = val
          .filter((column) => column.active || column.required)
          .map((column) => column.id);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    updateSelectedColumns(selectedColumns) {
      this.columns = this.columns.map((column) => {
        column.active = selectedColumns.some(
          (selected) => selected === column.id
        );
        return column;
      });
      this.$emit("update:value", this.columns);
    },
  },
};
</script>

<style lang="scss" scoped>
.dynamic-columns-list {
  padding: 0;

  ::v-deep {
    .v-list-item {
      padding: 16px;
      height: unset !important;
      margin: 0 !important;

      .v-input__slot {
        gap: 8px;
      }
    }
  }
}
</style>
